import { CommonModule } from "@angular/common";
import { Component, inject, Injectable } from "@angular/core";

import {
    getDialogFactoryBase,
    IDialogButton,
    IDialogComponent,
    LgDialogRef,
} from "@logex/framework/ui-core";

export interface IUniversalDialogResult {
    result: string;
}

export interface IUniversalDialogConfig {
    title: string;
    content: string[];
    closeOnOverlayClick: boolean;
    allowMaximize: boolean;
}

@Component({
    selector: "codman-universal-dailog",
    templateUrl: "./universal-dialog.component.html",
    styleUrls: ["./universal-dialog.component.scss"],
    standalone: true,
    imports: [CommonModule],
})
export class SharedUniversalDialogComponent
    implements IDialogComponent<SharedUniversalDialogComponent>
{
    private _dialogRef = inject(LgDialogRef<SharedUniversalDialogComponent>);

    _title: string | undefined;
    _content: string[] = [];
    _closeOnOverlayClick: boolean | undefined;
    _allowMaximize: boolean | undefined;
    _dialogButtons: IDialogButton[] = [
        {
            textLc: "APP._Shared.Button.Close",
            onClick: (): void => this._close(),
        },
    ];

    _dialogClass = "lg-dialog lg-dialog--no-spacing lg-dialog--no-vertical-spacing lg-dialog--3col";

    show(config: IUniversalDialogConfig): void {
        this._title = config.title;
        this._content = config.content;
        this._closeOnOverlayClick = config.closeOnOverlayClick;
        this._allowMaximize = config.allowMaximize;
    }

    _close(): void {
        this._dialogRef.close();
    }
}

@Injectable()
export class UniversalDialog extends getDialogFactoryBase(SharedUniversalDialogComponent, "show") {}
